<template>
  <div>
    <v-dialog v-model="dialog" :persistent="persistant" max-width="800px">
      <v-card>
        <v-card-text class="text-center">
          <!-- <img src="" alt=""> -->
          <h2 class="primary--text">You've come to the end of your free trial!</h2>
          <p>Continue your journey and sign up to our 12 week programme today!</p>
        </v-card-text>
        <v-card-actions class="no-padding">
          <v-btn href="https://leaner-living.com/fresh-start/par-q" target="_blank" color="primary" block depressed dark>Sign Up Now</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: ['dialog', 'persistant'],
  mounted () {
  },
  methods: {
    goTo: function (title) {
      this.$router.push({name: title})
    }
  },
  computed: {
  }
}
</script>
<style scoped>
  /* .alert {
    position: absolute;
    bottom: -12px;
    left: 0;
    right: 0;
    margin: auto;
  } */
</style>



// WEBPACK FOOTER //
// src/components/partial/trial.vue